<template>
  <v-list three-line dark class="py-4 px-4 user-info">
    <v-list-tile>
      <v-avatar size="100px" class="mr-3">
        <img v-if="userInfo.photo" :src="userInfo.photo">
        <img v-else src="/img/empty-avatar.png">
      </v-avatar>
      <v-list-tile-content>
        <v-list-tile-title>
          <v-layout row align-center>
            <v-icon dark small>account_circle</v-icon>
            <div>
              <a :href="userProfileUrl" target="_blank" style="color: #F5F5F5; text-decoration: none"><span class="ml-2">{{userInfo.userId}} {{userInfo.name}} {{userInfo.surname}}</span></a>
            </div>
            <div
              v-if="userInfo.status === statuses.active"
              class="success white--text ml-2 px-3 body-1 user-info__status"
              >
              <span>Учится</span>
            </div>
            <div
              v-if="userInfo.status === statuses.readyToStart"
              class="warning white--text ml-2 px-3 body-1 user-info__status">
              <span>Готов к старту</span>
            </div>
            <div
              v-if="userInfo.status === statuses.readyToContinue"
              class="warning white--text ml-2 px-3 body-1 user-info__status">
              <span>Готов продолжать</span>
            </div>
            <div
              v-if="userInfo.status === statuses.graduated"
              class="primary white--text ml-2 px-3 body-1 user-info__status">
              <span>Закончил обучение</span>
            </div>
            <div
              v-if="userInfo.vacation === true"
              class="warning white--text ml-2 px-3 body-1 user-info__status">
              <span>В отпустке</span>
            </div>
          </v-layout>
        </v-list-tile-title>
        <v-list-tile-sub-title class="mt-3">
          <v-layout row>
            <v-flex xs2>
              <v-layout row align-center>
                <v-icon size="10px" dark class="mr-2">fiber_manual_record</v-icon>Текущий уровень:&nbsp
                <span class="user-info__number--yellow">{{userInfo.level}}</span>
              </v-layout>
            </v-flex>
            <v-flex xs3>
              <v-layout row align-center>
                <v-icon size="10px" dark class="mr-2">fiber_manual_record</v-icon>Средний фидбек от проверяемого:&nbsp
                <span class="user-info__number--yellow">{{userInfo.avgMarkFromExaminee}}</span>
              </v-layout>
            </v-flex>
            <v-flex xs2 class="mr-5">
              <v-layout row align-center>
                <v-icon size="10px" dark class="mx-2">fiber_manual_record</v-icon>Видимых предупреждений:&nbsp
                <span class="user-info__number--yellow">{{userInfo.warnings}}</span>
              </v-layout>
            </v-flex>
            <v-flex xs2>
              <v-layout row align-center>
                <v-icon size="10px" dark class="mx-2">fiber_manual_record</v-icon>Лучший ревьювер:&nbsp
                <span class="user-info__number--yellow">{{userInfo.bestReviewerRating}}</span>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-list-tile-sub-title>
        <v-list-tile-sub-title>
          <v-layout row>
            <v-flex xs2>
              <v-layout row align-center>
                <v-icon size="10px" dark class="mr-2">fiber_manual_record</v-icon>Средняя оценка:&nbsp
                <span class="user-info__number--yellow">{{userInfo.avgMarkForTasks}}</span>
              </v-layout>
            </v-flex>
            <v-flex xs3>
              <v-layout row align-center>
                <v-icon size="10px" dark class="mr-2">fiber_manual_record</v-icon>Средний фидбек от ревьювера:&nbsp
                <span class="user-info__number--yellow">{{userInfo.avgMarkFromReviewer}}</span>
              </v-layout>
            </v-flex>
            <v-flex xs2 class="mr-5">
              <v-layout row align-center>
                <v-icon size="10px" dark class="mx-2">fiber_manual_record</v-icon>Скрытых предупреждений:&nbsp
                <span class="user-info__number--yellow">{{userInfo.hiddenWarnings}}</span>
              </v-layout>
            </v-flex>
            <v-flex xs2>
              <v-layout row align-center>
                <v-icon size="10px" dark class="mx-2">fiber_manual_record</v-icon>Добряк:&nbsp
                <span class="user-info__number--yellow">{{userInfo.inflatedMarks}}</span>
              </v-layout>
            </v-flex>
          </v-layout>
        </v-list-tile-sub-title>
      </v-list-tile-content>
    </v-list-tile>
  </v-list>
</template>

<script>
import {urls} from "@/config";

export default {
  name: "UserInfo",
  props: [
    "userInfo",
    "statuses"
  ],
  data () {
    return {
      userProfileUrl: null
    }
  },
  mounted() {
    this.userProfileUrl = urls.signin + '/u/' + this.userInfo.uid;
  }
}
</script>

<style scoped>
  .user-info {
    border-bottom: 2px solid #4CAF50;
  }

  .user-info__status {
    border-radius: 10px;
  }

  .user-info__number--yellow {
    color: #FFF176;
  }

</style>
